"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const isPathNode_1 = __importDefault(require("./isPathNode"));
const getAllPathNodes = (nodes) => {
    return lodash_1.filter(nodes, isPathNode_1.default);
};
exports.default = getAllPathNodes;
